import ReactDOM from 'react-dom'

const NewPortal = ({ children }) => {
  return ReactDOM.createPortal(children, document.getElementById('portal'))
}

export default NewPortal
